import apiConfig from "../../config/api";

export const loadTabs = (title, subTitle = "", tabs, contentId) => ({
  type: "LOAD_TABS",
  title,
  subTitle,
  tabs,
  contentId,
});

export const changeTabIndex = (newContentId, tabPosition) => ({
  type: "CHANGE_TABS_INDEX",
  newContentId,
  tabPosition,
});

export const openCloseAcountMenu = (isOpenAccountMenu) => ({
  type: "OPEN_CLOSE_ACCOUNT_MENU",
  isOpenAccountMenu,
});

export const openCloseAccountPopOver = (isOpen) => ({
  type: "OPEN_CLOSE_ACCOUNT_POPOVER",
  isOpen,
});

export const askToken = (email) => async (dispatch) => {
  const params = {
    Id: "1",
    IdPerson: email,
    IdPersonType: "EMAIL",
    CallBackUri: apiConfig.callback,
  };

  const request = await fetch(
    `${apiConfig.apiUri}api/jwt`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      },
      credentials: "same-origin",
      body: JSON.stringify(params),
    }
  );

  if (request.status === 200) {
    const response = await request.json();
    const href = `${apiConfig.redUri}?token=${response.Token}`;
    window.open(href, "_blank");
  }
};
